import React, { Component } from 'react';
import {AuthContext} from "../../authContext";
import moment from "moment";

import Alert from "../shared/Alert";
import Button from "../shared/Button";
import Definition from "../shared/Definition";
import Loading from "../shared/Loading";
import { deleteProject, getProjectResources } from "../data/dataCIMToolkit";

import getFileSizeDescription from '../shared/utilities/getFileSizeDescription';
import getResourceIconFromType from '../shared/utilities/getResourceIconFromType';
import getFileTypeDescription from "../shared/utilities/getFileTypeDescription";
import Flex from "../shared/Flex";

class DeleteProject extends Component {
  static contextType = AuthContext;
  state = {
    isLoadingResources: true,
    isDeletingProject: false,
    projectResources: []
  };
  componentDidMount = async() => {
    if (this.props.projectData.ResourcesCount > 0) {
      const projectResources = await getProjectResources(this.props.projectData.ID, this.context.token);
      await this.setState({
        projectResources: projectResources.data
      });
    }
    await this.setState({isLoadingResources: false});
  };
  deleteProject = async () => {
    await this.setState({isDeletingProject: true});
    // console.log("This should now delete project", this.props.projectData.ID, this.context.token);
    await deleteProject(this.props.projectData.ID, this.context.token);
    //console.log("deleteProjectResponse", deleteProjectResponse);
    await this.setState({isDeletingProject: false});
    this.context.navigate('/projects');
  };
  static contextType = AuthContext;
  render() {
    return (
      <Alert>
        <h3>Delete project?</h3>
        <p>
          This will permanently delete the project and all associated CityCAD models.
        </p>
        <h4>Project Details</h4>
        <Definition>Name</Definition>
        {this.props.projectData.name}
        <Definition>Project created</Definition>
        {moment(this.props.projectData.createdAt).format('D MMMM YYYY')}
        <Definition>Description</Definition>
        {this.props.projectData.description}
        <Definition>Associated CityCAD models</Definition>
        <div>
          {this.props.projectData.resourcesCount === 0 && "None"}
          {this.state.isLoadingResources && <Loading />}
          {this.state.projectResources.map(resource => {
            return (
              <Flex style={{marginTop:"5px", paddingBottom: "5px", borderBottom:"1px solid #aa0000"}}>
                <Flex>
                  <div style={{maxWidth:"35px",paddingRight:"10px"}}>
                    {getResourceIconFromType()}
                  </div>
                  <div style={{textAlign:"left"}}>
                    {resource.name}<br />
                    <small>
                      {getFileTypeDescription(resource.type)}
                    </small>
                  </div>
                </Flex>
                <div>
                  <small>{getFileSizeDescription(resource.size)}</small>
                </div>
              </Flex>
            )
          })}
        </div>
        <Flex style={{marginTop:"7px"}}>
          <Button onClick={this.props.toggleDeleteProjectConfirmation}>
            Cancel
          </Button>
          <Button onClick={this.deleteProject} style={{backgroundColor:"#ff0000",border:"1px solid #aa0000",fontWeight:"bold",color:"#ffffff"}}>
            {this.state.isDeletingProject ? "Deleting" : "Delete Project"}
          </Button>
        </Flex>

      </Alert>
    )
  }
}

export default DeleteProject;
